/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink, useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { checkIsActive } from "../../../../_helpers";
import { useSelector } from "react-redux";
import {
  login,
  loginWithMobile,
  SignInWithMobile,
  VerifyLogin,
  VerifyRegister,
} from "../../../../../app/modules/Homepage/pages/widgets/components/cruds";
import {
  Dialog,
  DialogTitle,
  Slide,
  Tabs,
  Tab,
  TextField,
  Button,
  InputAdornment,
  LinearProgress,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "../../../../../app/utils/react-redux-hooks";
import { Formik } from "formik";
import { actions as authActions } from "../../../../../app/modules/Auth/_redux/authRedux";
import ReactCodeInput from "react-code-input";
import { DirectionsBus } from "@material-ui/icons";
import Countdown from "react-countdown";
import ReactLoading from "react-loading";
import AuthModal from "../../../../../app/modules/RUComponent/AuthModal";
import styled from "styled-components";

const FontSizeH2 = styled.div`
  font-size: calc(1.3rem + .6vw);
`;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function HeaderMenu({ layoutProps }) {
  const propsz = {
    className: "class-Input",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      backgroundColor: "red",
      color: "red",
      border: "1px solid red",
    },
  };

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const [display, setDisplay] = React.useState("none");
  const [open, setOpen] = React.useState(false);
  const [eventOpen, setEventOpen] = React.useState(false);
  const [value, setValue] = React.useState("login");
  const [verifyTime, setVerifyTime] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);
  const [codeErrMessage, setCodeErrMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [timeCounter, setTimeCounter] = React.useState(false);
  const [counterRemained, setCounterRemained] = React.useState(120000);

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const useStyles = makeStyles({
    barColorPrimary: {
      background: "red",
    },
  });

  const classes = useStyles();

  const counterRenderer = ({ total }) => {
    setCounterRemained(total);
    const mainMin = 120000;
    const onePercent = mainMin / 100;
    const leftedPercent = Math.floor(total / onePercent);

    return (
      <LinearProgress
        variant="determinate"
        value={leftedPercent}
        dir="ltr"
        style={{ height: "0.7rem", borderRadius: "10px" }}
        className={` w-75 mx-auto`}
      />
    );
  };

  const handleEventClose = () => {
    setEventOpen(false);
  };

  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setVerifyTime(false);
    setOpen(false);
  };

  const history = useHistory();

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      <Dialog
        open={eventOpen}
        onClose={handleEventClose}
        keepMounted
        className="p-10"
        PaperProps={{ style: { maxHeight: "unset" } }}
      >
        <div className="row container mx-auto p-7">
          <div className="col-12 d-flex justify-content-center">
            <DirectionsBus
              className="col-6"
              style={{
                fontSize: "10rem",
                color: "#6dd06d",
                transform: "rotate(90deg)",
              }}
            />
          </div>
          <div
            className="d-flex flex-column align-items-center justify-content-center my-10 container"
            style={{ gap: 10 }}
          >
            <FontSizeH2 className="text-dark"> این بخش به زودی اضافه خواهد شد</FontSizeH2>
          </div>
          <div className="col-12 p-2 my-2" style={{ height: "4rem" }}>
            <Button
              className="w-100 h-100 bg-white"
              style={{
                border: "0.5px solid #6dd06d",
                borderRadius: "13px",
              }}
              onClick={() => handleEventClose()}
            >
              <h6
                className="mx-auto my-auto"
                style={{
                  color: "#6dd06d",
                }}
              >
                بازگشت
              </h6>
            </Button>
          </div>
        </div>
      </Dialog>
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li className={`menu-item menu-item-rel ${getMenuItemActive("/")}`}>
          <NavLink className="menu-link" to="/">
            <span className="menu-text">جستجوی سفر اتوبوسی </span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/dashboard"
          )}`}
        >
          <NavLink className="menu-link" to="/ebus-charter">
            <span className="menu-text"> سرویس دربستی</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/dashboard"
          )}`}
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleEventOpen();
          }}
        >
          <NavLink className="menu-link" to="/">
            <span className="menu-text">جشنواره</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {authState?.user?.user ? (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              "/orders"
            )}`}
          >
            <NavLink className="menu-link" to="/Extradition">
              <span className="menu-text">استرداد بلیط اتوبوس</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        ) : (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              "/orders"
            )}`}
          >
            <span className="menu-link" onClick={() => handleClickOpen()}>
              <span className="menu-text">استرداد بلیط اتوبوس</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </span>
          </li>
        )}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/orders"
          )}`}
        >
          <NavLink className="menu-link" to="/activeCity">
            <span className="menu-text">شهرهای فعال</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}
      </ul>
      {/* <div className="d-md-none d-flex mt-auto ml-5">
        {!authState.user ? (
          <>
            <div className={"dropdown "}>
              <div data-offset="10px,0px" className="topbar-item">
                <a
                  // href={toAbsoluteUrl("/auth/login")}
                  className={
                    "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto text-dark"
                  }
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => {
                    setValue("login");
                    handleClickOpen();
                  }}
                >
                  ورود
                </a>
              </div>
            </div>
            <div className={"dropdown"}>
              <div
                style={{ whiteSpace: "nowrap" }}
                data-offset="10px,0px"
                className="topbar-item"
                onClick={() => {
                  setValue("register");
                  handleClickOpen();
                }}
              >
                <a
                  // href={toAbsoluteUrl("/auth/registration")}
                  className={
                    "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto text-dark"
                  }
                >
                  ثبت نام
                </a>
              </div>
            </div>
          </>
        ) : (
          <h3>
            {authState?.user?.user.firstName && authState?.user?.user.lastName
              ? `${authState?.user?.user.firstName} ${authState?.user?.user.lastName}`
              : "کاربر"}
          </h3>
        )}
      </div> */}
      {/*end::Header Nav*/}
      <AuthModal open={open} handleClose={handleClose} />
    </div>
  );
}
